module.exports = __webpack_public_path__ + "img/china_unicom.a4907612.svg";